module.exports = "/images/daily-limit.png?7cf5b0f875cee9ce372f1ccc55341141";